import _ from "lodash";

export default {
  namespaced: true,
  state: {
    activeCategory: {},
    banner: {
      src: require("../../assets/pictures/banner.png"),
    },
    categories: [
      { id: 0, displayName: "Awards", key: "awards", pictureCount: 7 },
      { id: 1, displayName: "Habitats", key: "habitats", pictureCount: 7 },
      { id: 2, displayName: "Turkeys", key: "turkeys", pictureCount: 5 },
      { id: 3, displayName: "Waterfowl", key: "waterfowl", pictureCount: 10 },
    ],
  },
  getters: {
    // allPictures: (state) => {
    //   const pictureNumbers = [...Array(state.totalPicturesCount).keys()];
    //   const pictures = [];
    //   pictureNumbers.forEach((p) =>
    //     pictures.push({
    //       src: require(`../../assets/pictures/${p + 1}.jpg`),
    //     })
    //   );

    //   return pictures;
    // },
    categories: (getters) => {
      return _.orderBy(getters.categories, ["sortOrder"], ["asc"]);
    },
    defaultCategory: (state) => {
      return state.categories[0];
    },
    awards: (state) => {
      const pictureCount = state.categories.filter((c) => c.key === "awards")[0]
        .pictureCount;
      const pictureNumbers = [...Array(pictureCount).keys()];
      const pictures = [];
      pictureNumbers.forEach((p) =>
        pictures.push({
          src: require(`../../assets/pictures/awards/award_${p + 1}.jpg`),
        })
      );
      return pictures;
    },
    habitats: (state) => {
      const pictureCount = state.categories.filter(
        (c) => c.key === "habitats"
      )[0].pictureCount;
      const pictureNumbers = [...Array(pictureCount).keys()];
      const pictures = [];
      pictureNumbers.forEach((p) =>
        pictures.push({
          src: require(`../../assets/pictures/habitats/habitat_${p + 1}.jpg`),
        })
      );
      return pictures;
    },
    turkeys: (state) => {
      const pictureCount = state.categories.filter(
        (c) => c.key === "turkeys"
      )[0].pictureCount;
      const pictureNumbers = [...Array(pictureCount).keys()];
      const pictures = [];
      pictureNumbers.forEach((p) =>
        pictures.push({
          src: require(`../../assets/pictures/turkeys/turkey_${p + 1}.jpg`),
        })
      );
      return pictures;
    },
    waterfowl: (state) => {
      const pictureCount = state.categories.filter(
        (c) => c.key === "waterfowl"
      )[0].pictureCount;
      const pictureNumbers = [...Array(pictureCount).keys()];
      const pictures = [];
      pictureNumbers.forEach((p) =>
        pictures.push({
          src: require(`../../assets/pictures/waterfowl/waterfowl_${p +
            1}.jpg`),
        })
      );
      return pictures;
    },
    // randomPictures: (state, getters) => {
    //   return _.sampleSize(getters.allPictures, state.totalPicturesCount);
    // },
    // topPictures: (state, getters) => (numberOfPictures) => {
    //   return numberOfPictures
    //     ? _.sampleSize(getters.allPictures, numberOfPictures)
    //     : getters.randomPictures;
    // },
  },
  mutations: {
    setActiveCategory: (state, category) => (state.activeCategory = category),
  },
  actions: {},
};
